<template>
<div class="input-field" style="width: 100%">
  
  <div class="select-wrapper" style="width: 100%">
    <div  class="select-dropdown dropdown-trigger elongating" :data-target="'dropdownselector'+identifier" v-if="elongating" v-show="!disabled">
    <p v-for="ritem in ritems">{{ritem}}</p>
  </div>
  <div  class="elongating" v-if="elongating" v-show="disabled">
    <p v-for="ritem in ritems">{{ritem}}</p>
  </div>
     <input type="text" readonly="true" v-model="labels" v-if="disabled" v-show="!elongating"/>
   <div class="dropdown-trigger" :data-target="'dropdownselector'+identifier" v-show="!disabled">
    <input class="select-dropdown" type="text" readonly="true" v-model="labels" v-if="!disabled" v-show="!elongating"/>
    <i class="material-icons dp6 " style="top: 5px;position: absolute;right: 5px;z-index: 999;" >expand_more</i>
  </div>
  <div v-show="disabled">
    <input class="select-dropdown" type="text" readonly="true" v-model="labels" v-if="!disabled" v-show="!elongating"/>
    <i class="material-icons dp6 " style="top: 5px;position: absolute;right: 5px;z-index: 999;" >expand_more</i>
  </div>
  </div>
  <div :id="'dropdownselector'+identifier" class='dropdown-content select-dropdown multiple-select-dropdown' style="overflow-x: hidden;">
     <div  class='searchterm' style="position: sticky; top: 0px; background-color: white; z-index: inherit;">
      <p><input v-model="searchterm"/></p>
    </div>
  <ul >
   
    <li v-if="recommendations.length > 0">
        <span>
          <label>
            <input v-model="showall"  type="checkbox"/>
            <span>{{$t('menu.buttons.selectall')}}</span>
          </label>
        </span>
    </li>
    <template v-for="item in filteredItems" v-if="groupitems == undefined">
      <li>
        <span>
          <label>
            <input :value="item.value"  v-model="selectionsLocal"  type="checkbox" v-if="!singlemode" />
            <template v-if="singlemode">
              <p v-on:click="selectedItem(item)">{{item.name}}</p>
            </template>
            <span style="width: 100%;" v-if="!singlemode">{{item.name}}</span>
          </label>
        </span>
      </li>
     
    </template>
    
   <template v-for="group in filteredGroups" v-if="groupitems != undefined">
    <label>
      <span v-html="boldString(group.name, searchterm)"/>
    </label>
      <ul>
        <template v-for="item in group.items">
          <li tabindex="-1">
              <span>
              <label>
                <input :value="item.value"  v-model="selectionsLocal"  type="checkbox"  v-if="!singlemode" selected />
                <template v-if="singlemode">
                  <p v-on:click="selectedItem(item)" v-html="boldString(item.name, searchterm)">{{item.name}}</p>
                </template>
                <span style="width: 80%;" v-if="!singlemode">{{item.name}}</span>
                <template v-if="dosagesdict[item.value] != undefined && shortened">
                  <input style="width: 10%;" v-model="dosagesdict[item.value].dosage"/>
                  {{dosagesdict[item.value].dosage_unit}}
                </template>
              </label>
            </span>
          </li>
          <li v-if="hasDosage(item.value) && !shortened && !item._destroy">
            <dosageeditor :dosage="dosagesdict[item.value]" :withConsumption="withConsumption" v-if="!(dosagesdict[item.value]._destroy)"/>
          </li>
        </template>
    </ul>
    </template>
   
  </ul>
  <div class="row" style="position: sticky; bottom: 0px; background-color: white; padding: 10px;">
    <div class="col offset-s5 s3">
      <button tabindex="-1" v-on:click="cancel()" class="btn-small cancelbutton" style="text-align: center; line-height: 1.5; padding: 10px;">{{$t('menu.buttons.cancel_changes')}}</button>
    </div>
    <div class="col s4">
      <button tabindex="-1" v-on:click="applyDosages()" class="btn-small green" style="text-align: center; line-height: 1.5; padding: 10px;">{{$t('selectdosages.changedosage')}}</button>
    </div>
    
  </div>
</div>
</div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
    data: function () {
        return {
          searchterm: "",
          showall: false,
          dosagesdict: {},
          dosages_local: []
        }
    },
    props: {
      selections: { type: [Array, Number], default() {
            return []
        }},
      dosages: Array,
      items: Array,
      identifier: String,
      disabled: Boolean,
      elongating: Boolean,
      singlemode: Boolean,
      groupitems: String,
      withConsumption: { type: Boolean, default() {
            return false
        }
      },
      shortened: { type: Boolean, default() {
            return false
        }
      },
      recommendations: { type: Array, default() {
            return []
        }
      },
      allowRemove: {type:  Boolean, default(){
        return false;
      }}
    },
    model: {
        prop: 'dosages',
        event: 'listchange'
    },
    mounted: function(){
      var elemss = this.$el.querySelectorAll('.dropdown-trigger');
      this.instance = M.Dropdown.init(elemss, {closeOnClick: false});
      var doses = JSON.parse(JSON.stringify(this.dosages || []));
      this.dosagesdict = _.keyBy(doses, 'substance_id');
      this.dosages_local = doses;
    },
    methods: {
      selectedItem(item){
        this.selectionsLocal = item.value;
        this.instance[0].close();
        this.dosages_local.push({substance_id: item.value, dose: 0, consumed: 0, replaced: 0, dose_change: false, new_dose: 0});
      },
      boldString(str, find){
        var re = new RegExp(find, 'gi');
        if(find.length > 0 && str.match(re) && str.match(re).length > 0){
          return str.replace(re, '<b>'+str.match(re)[0]+'</b>');
        }else{
          return str;
        }
      },
      hasDosage(sid){
        var sub = _.keyBy(this.dosages_local, 'substance_id')[sid];
        return _.isUndefined(sub) == false;
      },
      dosageForSubstance(sid){
        var sub = _.keyBy(this.dosages_local, 'substance_id')[sid];
        if(_.isUndefined(sub)) {
          var ndos = {substance_id: sid, dosage_unit: 'szt', dosage: 0, consumed: 0, replaced: 0, dose_change: false, new_dose: 0}
          this.dosages_local.push(ndos)
          return ndos;
        }else return sub;
      },
      applyDosages: function(){
        this.$emit('listchange', this.dosages_local)
        this.instance[0].close();
      },
      cancel: function(){
        this.instance[0].close();
      }
    },
  computed: {
    selectionsLocal: {
      get: function(){
        return _.map(this.dosages_local, 'substance_id')
      },
      set: function(value){
        var added = _.difference(value, _.map(this.dosages_local, 'substance_id'));
        var removed = _.difference(_.map(this.dosages_local, 'substance_id'), value);
        for (var i = added.length - 1; i >= 0; i--) {
          if(_.keyBy(this.dosages_local, 'substance_id')[added[i]] == undefined){
            var substance = _(this.items).map('items').flatten().keyBy('id').value()[added[i]]
            var ndos = {substance_id: added[i], dosage: 0, consumed: 0, replaced: 0, dose_change: true, new_dose: 0, dosage_unit: substance.unit}
            this.dosages_local.push(ndos)
            this.dosagesdict[added[i]] = ndos
          }else{
            var found = _.keyBy(this.dosages_local, 'substance_id')[added[i]];
            if(found.dose_change && found.new_dose == 0){
              found.dose_change = false;
            }
          }
        }
        
        for (var i = removed.length - 1; i >= 0; i--) {
          var found = _.keyBy(this.dosages_local, 'substance_id')[removed[i]];
          if(found != undefined){
            if(found.dosage == 0 || !this.withConsumption ||  this.allowRemove){
              if(_.isUndefined(found.id)){
                this.dosages_local.splice(this.dosages_local.indexOf(found), 1)
                delete this.dosagesdict[removed[i]]
              }else{
                found._destroy = true;
              }
            }else{
              found.dose_change = true;
              found.new_dose = 0
            }
          }
        }
        this.$forceUpdate();
      }
    },
    ritems(){
      var lbs = _.zipObject(this.items.map(item => [item.value]), this.items.map(item => [item.name]))
      if(_.isUndefined(this.selectionsLocal)){
        return []
      }else return _.flatten(this.selectionsLocal.map(item => lbs[item]))
    },
    
    labels() {
      var lbs = {};
      if(this.groupitems == undefined){
        lbs = _.zipObject(this.items.map(item => [item.value]), this.items.map(item => [item.name]))
      }else{
        for (var i = this.items.length - 1; i >= 0; i--) {
          lbs = _.extend(lbs, _.zipObject(this.items[i].items.map(item => [item.id]), this.items[i].items.map(item => [item.name])))
        }
      }
      
      if(_.isUndefined(this.selectionsLocal)){
        return ""
      }else if(this.singlemode){
        var item = _.keyBy(_.flatten(_.map(this.items, this.groupitems)),'id')[this.selectionsLocal];
        if(_.isObject(item)) {return item.name;} else { return this.$t('menu.buttons.select') }
      }else{
        var mapa = _.keyBy(this.dosages, 'substance_id');
        return _.compact(_.flatten(_.keys(mapa).map(item => {
            var dose = mapa[item];
            var out = ""
            if(dose != undefined) {
              out = out + " (" + dose.dosage + " " + dose.dosage_unit
              if(this.shortened == false){
                out = out + ", " + dose.replaced + " " + dose.dosage_unit
                if(this.withConsumption) {
                  out = out + ", " + dose.consumed + " " + dose.dosage_unit;
                }
                if(dose.dose_change){
                  out = out + ", " + dose.new_dose + " " + dose.dosage_unit;
                }
              }
              return lbs[item] + out + " )";
            }
            else return lbs[item];
              }
            )
          )
        ).join(", ")
      }
    },
    
    filteredGroups: function() {
      var that = this;
      
      var imts = _.map(this.items, function(item){
          if(item instanceof Object){

              var out = _.compact(_.map(item[that.groupitems], function(subitem){
                  var fromrecos = that.recommendations.indexOf(subitem.id) > -1;
                  var fromselections = that.selections.indexOf(subitem.id) > -1;
                  var fromdosages =  _.keys(_.keyBy(that.dosages, 'substance_id')).indexOf(subitem.id) > -1;

                  if(subitem.name.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1 && (fromrecos || that.showall || fromselections || fromdosages || that.recommendations.length == 0)){
                    return {
                      value: subitem.id,
                      name: subitem.name
                    }
                  }
              }));
              if(out.length > 0){
                return {
                  name: item.name,
                  items: out
                }
              }
        }
        if(item instanceof String){
           if(item.toLowerCase().indexOf(that.searchterm.toLowerCase()) !== -1){
            return {
            }
           }
        }
      }
      );
      return _.compact(imts);

    },
    filteredItems: function() {
      if(this.items.length == 0){
        return [];
      }else{
        return _.map(this.items.filter(i => {
          if(i instanceof Object){
            var iname = ""
            if(_.isNull(i.name) == false) iname = i.name.toLowerCase();
            if(this.groupitems){
               iname = iname + _.map(i[this.groupitems], 'name').join(" ").toLowerCase();
            }
            return iname.indexOf(this.searchterm.toLowerCase()) !== -1;
          }else{
            return i.indexOf(this.searchterm.toLowerCase()) !== -1;
          }
        }), item => {
          if(item instanceof Object){
            return item;
          }
          if(_.isString(item)){
            return {
              name: item,
              value: item
            }
          }
        });
      }
    },
  }
}
</script>
<style scoped>
.searchterm{
  min-height: initial;
}
.searchterm input {
  margin: 0px;
  width: 95%;
}
.input-field{
  width: 100% !important;
}
.select-wrapper{
  width: 100% !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
}
[type="checkbox"]:checked+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}
[type="checkbox"]:selected+span:not(.lever):before {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
}
.dropdown-content p{
  margin-top: 0px;
  margin-bottom: 0px;
}
.elongating{
    border: 1px solid #9e9e9e;
    margin-bottom: 15px;
    border-radius: 4px;
    padding: 15px;
}
input[type=range]{
  border: 0px !important;
}
</style>
